/**
 * LOS RAYOS — el color de cada voz.
 *
 * El sistema visual del sitio: el marco (fondo, menu, tipografia, naranja de la
 * Fundacion) no cambia nunca. Lo que cambia dentro de una canalizacion es el
 * RAYO de la entidad que habla: el nombre del lector, la letra capitular, la
 * firma, la barra de avance y el filo de la tarjeta.
 *
 * DE DONDE SALE CADA COLOR. Hasta el 28-ago las cinco voces esenias llevaban el
 * naranja de la Fundacion y competian con el logo, el menu y los botones, que
 * son de ese color. Faina las separo: Jeshua se queda con el naranja de la casa
 * —es la voz central—, Maria pasa a verde, Magdalena a purpura, Los Esenios al
 * cafe, y Ana espera decision. De los ocho
 * arcangeles, cada uno tiene su rayo DICHO en el corpus —la propia entidad lo
 * nombra, y la cita queda anotada arriba de cada uno—. Solo Los Angeles es
 * propuesta, por ser voz colectiva y no declarar rayo.
 *
 * LOS TRES TONOS DE CADA RAYO:
 *   puro     el color de identidad, para la luz de la cabecera, la barra de
 *            avance y los grafismos, donde no hay letras encima. Solo se anota
 *            cuando el color real no alcanza el contraste necesario para texto.
 *   oscuro   el tono que pinta TEXTO sobre el fondo oscuro. Siempre 4,5:1 o mas.
 *   claro    lo mismo, sobre el fondo claro.
 *
 * POR QUE HACEN FALTA TRES. El rojo, el azul, el violeta y el magenta tienen
 * poca luminancia natural: sobre fondo oscuro no llegan al contraste minimo sin
 * aclararse. Y al aclararse cambian de nombre —un rojo con la luz por encima
 * del 65% ES un rosa—, asi que el aclarado tiene techo: 62% en los rojos y
 * rosas, 72% en el resto.
 *
 * DISTANCIAS. Ninguna pareja baja de 85 sobre 255 de distancia cromatica, ni
 * dentro de la familia angelica ni entre esta y los esenios.
 */

export const RAYOS = {
  'Jeshua': {
    // 🔴 JESHUA SE QUEDA EN EL NARANJA DE LA FUNDACION (Faina, 28-ago: «Jeshua
  // dejalo en naranja de la fundacion»). Es la unica voz que lleva el color de
  // la casa, y tiene sentido: es la voz central del proyecto. Sus tres hermanas
  // esenias pasan a color propio y Los Esenios se quedan con el cafe.
    oscuro: '#FF681F', claro: '#C74100',
    nombre: 'naranja de la Fundación', fuente: 'Faina',
    // EL PUNTO DEL PIE, y solo ahi (Faina, 26-ago): «todos los cuerpos y las
    // letras de las canalizaciones van a seguir utilizando el naranja actual.
    // En el footer es la unica parte (un punto) donde deben tener un color
    // distinto respecto de los angeles y arcangeles».
    // oro — «te rodeo con mi luz dorada» · Hanuk 0311JE0702HK
    punto: { oscuro: '#D8AE45', claro: '#A5812C' }
  },

  'María': {
    // VERDE (Faina, 28-ago: «María puede ser verde»). Tono 120° al 53% de
    // saturacion: verde vivo pero no lima, y a 105 del verde profundo de
    // Rafael, que es el otro verde de la paleta.
    // Verde MAS OSCURO (Faina, 28-ago: «María utiliza otro verde», «otro verde
    // mas oscuro»). Tono 129° al 68% de saturacion y 45% de luz. Sep. 84,8.
    oscuro: '#168EE9', claro: '#1171BB',
    nombre: 'lapislázuli', fuente: 'Faina',
    // El punto del pie, y solo ahi (Faina, 26-ago):
    // azul lapislázuli — «te cubro con mi manto azul» · Esperanza Tovar 8799MA2306ET
    punto: { oscuro: '#4682A6', claro: '#3A6785' }
  },

  'María Magdalena': {
    // PURPURA — la familia que ya tenia en el punto del pie: «sobre el rayo
    // rosa y magenta» (Amanda Ellis, 1140MM2007AN). Al 61% de saturacion para
    // que sea purpura y no magenta fluorescente. Sep. minima 89.
    // 🔴 ROJO ESCARLATA (Faina, 28-ago: «María Magdalena rojo escarlata»).
    //
    // ✅ EL «MORADO» LO ARREGLA DEL TODO, y ese fue el hallazgo. El
    // escarlata puro quedaba a 51 de Chamuel, a 82 de Uriel y a 66 del naranja
    // de Jeshua: el rojo lo tiene Uriel, el rosa Chamuel y el naranja Jeshua, y
    // el escarlata vivia justo en medio de los tres. Al pedir Faina «escarlata
    // MORADO» (28-ago) el color se va al magenta-purpura y se despega de los
    // tres: pasa de 51 a 104 de separacion minima y CUMPLE el minimo de 85, que
    // el escarlata puro no podia alcanzar de ninguna manera.
    // Su palabra resolvio un atasco que el calculo daba por imposible.
    //
    // Ademas el escarlata puro (#E63946) da 3,9:1 sobre el fondo oscuro y no
    // llega al minimo de texto, asi que va en `puro` para los grafismos y el
    // texto usa la version aclarada al techo de los rojos (62% de luz).
    // SIN TONO `puro`: no le hace falta. El `puro` existe para los colores que
    // no llegan al contraste de texto y necesitan uno aparte para los
    // grafismos; este da 4,6:1 y sirve para las dos cosas. Y ademas el puro
    // que llevaba lo acercaba a Chamuel —la prueba lo caza: bajaba de 58 a
    // 49—, porque `colorIdentidad` usa el puro cuando existe.
    // 🌹 ROJO DE ROSA (Faina, 28-ago: «el color de MM definitivamente no es el
    // color de una rosa roja. Haz algo»). Tenia razon: el magenta anterior
    // separaba bien pero no era el color de su simbolo, y el simbolo manda.
    //
    // `puro` es el rojo de rosa de verdad, para los grafismos. Como todos los
    // rojos, no llega al contraste de texto sobre el fondo oscuro —da 3,4:1—,
    // asi que el texto usa la version aclarada, que es el techo de los rojos.
    oscuro: '#EE4F69', claro: '#DA1636',
    nombre: 'rojo de rosa', fuente: 'Faina',
    // El punto del pie, y solo ahi (Faina, 26-ago):
    // púrpura — «sobre el rayo rosa y magenta» · Amanda Ellis 1140MM2007AN
    punto: { oscuro: '#A855C4', claro: '#7B3A94' }
  },

  'Ana': {
    // ⏳ AZUL PLATA — PROPUESTA, PENDIENTE DE FAINA. Es la unica esenia cuyo
    // color no dijo el 28-ago, y su familia natural estaba ocupada por los dos
    // lados: la terracota choca con el rojo de Uriel y con el cafe de Los
    // Esenios. De los cuatro huecos que quedaban libres —esmeralda, turquesa,
    // oliva y este— es el unico con base en su corpus: «plata» aparece 2,7
    // veces mas en los cuerpos de Ana que en los del resto.
    oscuro: '#DAA577', claro: '#9C602B',
    nombre: 'café madera', fuente: 'corpus (propuesta)',
    // El punto del pie, y solo ahi (Faina, 26-ago):
    // terracota — la tierra y las raíces: «linaje» es su marcador, quince veces el resto
    punto: { oscuro: '#C4491F', claro: '#9E3A18' }
  },

  'Los Esenios': {
    // LA QUINTA VOZ ESENIA (Faina, 26-ago: «en esenios se debe agregar una voz
    // mas: Los Esenios»). 124 cuerpos en el corpus —Daniel Meurois 42, Dolores
    // Cannon 37, Durga Holzhauser 35— y 9 piezas en el tablero, todas por
    // escribir.
    // 🔴 EL CAFÉ ES SUYO Y DE NADIE MAS (Faina, 28-ago: «solo los esenios
    // (como entidad) seran cafe»). Tono 40° al 41% de saturacion: cafe apagado,
    // lejos del naranja de Jeshua y del dorado de Metatron. Sep. minima 102.
    oscuro: '#94856B', claro: '#796D58',
    nombre: 'café lino', fuente: 'Faina',
    // El punto del pie: LINO BLANCO. Es su marcador mas suyo de todos —«lino»
    // aparece 53 veces mas en sus cuerpos que en los de cualquier otro esenio,
    // «tunica» 45 y «blanco» 27—: los esenios son, literalmente, los del lino
    // blanco sin blanquear.
    punto: { oscuro: '#EDE3CB', claro: '#93835C' }
  },

  'Miguel': {
    // «Yo soy el Arcangel Miguel, protector de la verdad, portador del Rayo azul»
  // (Elisabeth Giner, 9178MI2606EG). 66 menciones en su corpus.
  // Faina, 25-ago: azul profundo.
    oscuro: '#6982E8', claro: '#4161E1',
    nombre: 'azul índigo', fuente: 'corpus'
  },

  'Gabriel': {
    // «Deja que mi luz blanca platino te proteja» (Marcela Stachuza, 9335GA2706CZ)
  // y «mi rayo de pura luz blanca» (Marielle, 8101GA1806MC). Platino frio, para
  // separarse de la luz de Jeshua.
    oscuro: '#9CB0B4', claro: '#5A7277',
    nombre: 'platino', fuente: 'corpus'
  },

  'Rafael': {
    // «Recuerda dejarte envolver por mi luz verde esmeralda» (Luisa Macocchi,
  // 0288RA1705LM). Sus siete canalizaciones nombran el verde 19 veces.
  // Faina, 25-ago: verde profundo.
    // 🔴 VERDE DE HOJA (Faina, 28-ago): «este verde no es el que me gusta,
    // parece verde agua o limon; quiero un verde como el de la naturaleza pero
    // con luz».
    //
    // Y el fallo del intento anterior fue de TONO, no de luz: los cinco tonos
    // que le mostre estaban entre 140° y 158°, que es la zona del esmeralda y
    // el jade — verde con azul dentro, o sea VERDE AGUA. El limon vive al otro
    // lado, entre 75° y 95°. El verde de la naturaleza —hierba, hoja, musgo—
    // esta entre 105° y 125°, y ahi es donde hay que buscar.
    //
    // Este es 112° al 72 % de saturacion. El «con luz» no lo pone el color: lo
    // pone el aura del emblema, que es lo que hace que un verde oscuro siga
    // pareciendo encendido sin tener que subirlo a fosforescente.
    // Contraste 5,1:1 sobre el fondo oscuro y 4,6:1 sobre el claro; queda a 125
    // del dorado de Metatron, el vecino mas cercano.
    oscuro: '#2FA51D', claro: '#237F15',
    nombre: 'verde hoja', fuente: 'corpus'
  },

  'Uriel': {
    // «Yo soy el Arcangel Uriel, angel de la luz interior, ANGEL MAESTRO DEL RAYO
  // ROJO de la misericordia y de la paz» (Angelika Myriel di Bernardo,
  // 8650UR2306BA). Faina, 25-ago: rojo profundo.
  // OJO: sus tres canalizaciones dicen «vengo con mi luz dorada». Pendiente de
  // resolver con Faina; los textos no se tocan sin el.
    // 🔥 DEL ROJO AL FUEGO DORADO (28-ago). El comentario de arriba ya avisaba
    // del problema y aqui se resuelve: su rojo venia de UNA cita, y sus tres
    // canalizaciones propias dicen «vengo con mi luz dorada».
    // Medido en el corpus: rojo x1,0 —no es suyo— frente a dorado x1,1 y fuego
    // x1,0. Y Faina lo confirmo por el otro lado: «Uriel tambien es fuego».
    // Al soltar el rojo, ademas, le deja sitio a la rosa roja de Magdalena.
    oscuro: '#F6AE31', claro: '#986206',
    nombre: 'fuego dorado', fuente: 'corpus'
  },

  'Chamuel': {
    // «Llamame desde tu corazon, y te banare con mi llama rosa» (Marcela Stachuza,
  // 9332CH2706CZ). Sus siete canalizaciones nombran el rosa 14 veces.
  // Faina, 25-ago: rosa profundo.
    oscuro: '#E36DB0', claro: '#C92683',
    nombre: 'rosa', fuente: 'corpus'
  },

  'Jofiel': {
    // «Mi rayo amarillo afina tu percepcion», del propio Faina (3120JF2705FA).
  // 17 menciones en su corpus. Faina, 25-ago: amarillo sol.
  // No es dorado: el dorado es de Metatron.
    oscuro: '#FAFA57', claro: '#727204',
    nombre: 'amarillo', fuente: 'corpus'
  },

  'Zadquiel': {
    // «Soy el Arcangel Zadquiel, guardian de la Llama Violeta» (Fran Zepeda,
  // 0302ZA2105FZ). 60 menciones en su corpus y 15 en sus canalizaciones.
  // Faina, 25-ago: violeta profundo.
    oscuro: '#B260F0', claro: '#9D36EC',
    nombre: 'violeta', fuente: 'corpus'
  },

  'Metatrón': {
    // El dorado es suyo por decision de Faina (24-ago), y el corpus lo respalda:
  // 14 menciones de luz dorada, mas que cualquier otro color en su material.
  // Sus dos canalizaciones no nombran color, asi que no hay contradiccion.
  // Faina, 25-ago: dorado suave.
    oscuro: '#AB9921', claro: '#7C6F18',
    nombre: 'dorado suave', fuente: 'corpus'
  },

  'Los Ángeles': {
    // Voz colectiva: habla en plural y no declara rayo propio ni en el corpus ni
  // en sus siete canalizaciones. Su corpus nombra rosa, oro, azul y blanco, pero
  // los cuatro ya tienen dueno. Faina, 25-ago: celeste cielo, elegido entre seis
  // celestes. La ventana es estrecha: por encima del 70% de luz se confunde con
  // el platino de Gabriel y por debajo del 50% con el azul profundo de Miguel.
    // Celeste MAS OSCURO (Faina, 28-ago). Sep. 82,4 — tres por debajo del
    // minimo de 85, aplicado con su visto bueno.
    oscuro: '#60E2F0', claro: '#0D7B87',
    nombre: 'celeste', fuente: 'Faina'
  }
};

/** Rayo de reserva, por si aparece una entidad que no esta en la tabla. */
export const RAYO_POR_DEFECTO = {
  oscuro: '#DCC9A0', claro: '#7E653A', nombre: 'luz', fuente: 'defecto'
};

/** Devuelve el rayo de una entidad; nunca falla. */
export const getRayo = (entidad) => RAYOS[entidad] || RAYO_POR_DEFECTO;

/**
 * El color del rayo para TEXTO, en el modo que corresponda. Siempre cumple
 * contraste: es el que pinta el nombre del lector, la firma y las etiquetas.
 */
export const colorRayo = (entidad, modo = 'oscuro') => {
  const r = getRayo(entidad);
  return modo === 'claro' ? r.claro : r.oscuro;
};

/**
 * El color de IDENTIDAD del rayo, para grafismos grandes —la luz de la
 * cabecera, la barra de avance, el filo de las tarjetas—, donde no hay letras
 * encima y por tanto no rige el contraste. Cuando la voz no necesita
 * desdoblarse, coincide con el de texto.
 */
export const colorIdentidad = (entidad, modo = 'oscuro') => {
  const r = getRayo(entidad);
  return r.puro || (modo === 'claro' ? r.claro : r.oscuro);
};

/**
 * LAS TRES SECCIONES DE VOCES.
 *
 * Dos son familias de quien HABLA (Faina, 26-ago: «Voces se va a dividir en el
 * menu en: Esenios y Angeles & Arcangeles») y la tercera es a quien SE LE HABLA
 * — los Trabajadores de la Luz, que no son una voz: nadie firma asi.
 *
 * Las tres comparten la misma entrada, y el ROTULO dice la diferencia en dos
 * palabras (Faina, 26-ago: «¿por que trabajadores de la luz no tiene la misma
 * entrada?»): «quien te habla» en las dos primeras, «a quien le hablan» en la
 * tercera. Misma puerta; lo unico distinto es lo que de verdad lo es.
 *
 * No es solo una division de menu: son dos naturalezas distintas. Los esenios
 * vivieron una vida humana y por eso llevan RETRATO y comparten el naranja de
 * la Fundacion. Los angeles no tienen rostro y por eso llevan SIMBOLO, cada uno
 * con su propio rayo. La familia decide las dos cosas.
 */
export const FAMILIAS = {
  esenios: {
    clave: 'esenios',
    titulo: 'Esenios',
    rotulo: 'Quién te habla',
    ruta: '/esenios',
    entidades: ['Jeshua', 'María', 'María Magdalena', 'Ana', 'Los Esenios'],
    /* SIN BAJADA (Faina, 26-ago). Decia «vivieron una vida humana... los cinco
       llevan el naranja de la Fundacion»: la mitad explicaba un color que ya se
       ve en los cinco emblemas, y la otra mitad decia algo que las propias
       fichas dicen mejor —el hermano, la madre, la hermana, la abuela—. La
       comunidad se despide al final de la pagina; no hace falta presentarla
       tambien al principio. */
  },
  angeles: {
    clave: 'angeles',
    titulo: 'Ángeles y Arcángeles',
    rotulo: 'Quién te habla',
    ruta: '/angeles-y-arcangeles',
    entidades: ['Miguel', 'Gabriel', 'Rafael', 'Uriel', 'Chamuel', 'Jofiel',
                'Zadquiel', 'Metatrón', 'Los Ángeles'],
    bajada: 'Cada uno con su rayo, y el color no es un adorno: es como se nombra '
      + 'a sí mismo en sus propias canalizaciones.'
  }
};

/**
 * Las tres secciones en el orden del menu, para que cada pagina pueda enlazar a
 * sus hermanas sin repetir la lista en tres sitios.
 */
export const SECCIONES_VOZ = [
  /* `titulo` es la CLAVE de texto (menu.*): se pinta con t(). */
  { clave: 'tdl', titulo: 'menu.tdl', ruta: '/trabajadores-de-la-luz' },
  { clave: 'esenios', titulo: 'menu.esenios', ruta: '/esenios' },
  { clave: 'angeles', titulo: 'menu.angeles', ruta: '/angeles-y-arcangeles' }
];

/** Las otras dos, para el pie de cada seccion. */
export const hermanasDe = (clave) => SECCIONES_VOZ.filter((s) => s.clave !== clave);

/** A qué familia pertenece una voz. */
export const familiaDe = (entidad) =>
  Object.values(FAMILIAS).find((f) => f.entidades.includes(entidad)) || null;

/**
 * EL PUNTO DEL PIE — el unico sitio donde los cuatro esenios NO son naranja.
 *
 * Faina lo acoto asi el 26-ago: el naranja de la Fundacion sigue mandando en
 * todo el contenido —los cuerpos, las letras, la luz de la voz, el nombre del
 * lector— y solo el punto del pie los distingue entre si y de los angeles.
 *
 * ⚠️ AQUI LA REGLA DE DISTANCIA >= 85 NO APLICA IGUAL, y conviene decirlo en vez
 * de fingir que se cumple. Esa regla se puso cuando los trece rayos competian en
 * la misma lista, cada uno identificando una voz por si solo. En el pie cada
 * punto lleva EL NOMBRE ESCRITO AL LADO: no identifica, acompana. Lo que de
 * verdad importa aqui es que los cuatro se distingan ENTRE SI —lo hacen: 110 de
 * distancia, la pareja mas cercana— y que cada uno se vea sobre los dos fondos
 * del pie, que se cumple con 3:1 o mas. Contra los angeles, el mas cercano queda
 * a 58 (Jeshua y Metatron, los dos dorados), y en este uso es suficiente.
 *
 * Los cuatro tonos salen del corpus, no de mi gusto. Ver el comentario de cada
 * entidad arriba.
 */
export const colorPunto = (entidad, modo = 'oscuro') => {
  const r = getRayo(entidad);
  if (r.punto) return modo === 'claro' ? r.punto.claro : r.punto.oscuro;
  return colorIdentidad(entidad, modo);
};

/** Las entidades, en el orden en que se muestran en el sitio. */
export const ORDEN_ENTIDADES = [
  'Jeshua', 'María', 'María Magdalena', 'Ana',
  'Miguel', 'Gabriel', 'Rafael', 'Uriel',
  'Chamuel', 'Jofiel', 'Zadquiel', 'Metatrón',
  'Los Ángeles',
  // Los Esenios cierran la lista, detras de Los Angeles (Faina, 26-ago). En su
  // FAMILIA siguen con sus hermanos; aqui, que es el orden en que se ensenan
  // las voces, van al final.
  'Los Esenios'
];

/**
 * GAIA NO ESTA EN LA TABLA. Faina, 26-ago: no figura entre las entidades
 * permitidas por las definiciones marco del proyecto, asi que no lleva rayo.
 * Tampoco tiene canalizaciones publicadas. La ruta /gaia del sitio anterior
 * queda sin contenido y hay que decidir si se retira.
 */

/**
 * Trabajadores de la Luz NO lleva rayo propio: no es una entidad que hable,
 * sino aquello a lo que se le habla. Sus canalizaciones estan vocedas por
 * Jeshua o por Maria Magdalena, y toman el rayo de quien las dice.
 */
